module.exports = __webpack_public_path__ + "img/uy.fcb52bcb.svg";